import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ExtraOptions, PreloadAllModules, RouteReuseStrategy, RouterModule } from '@angular/router';
import { MarkdownModule } from 'ngx-markdown';
import { FuseModule } from '@fuse';
import { FuseConfigModule } from '@fuse/services/config';
import { FuseMockApiModule } from '@fuse/lib/mock-api';
import { AuroraModule, AuroraLangService, JsonLangService, RouteReuseStrategyService } from '@aurora';
import { CoreModule } from 'app/core/core.module';
import { appConfig } from 'app/core/config/app.config';
import { mockApiServices } from 'app/mock-api';
import { LayoutModule } from 'app/layout/layout.module';
import { AppComponent } from 'app/app.component';
import { appRoutes } from 'app/app.routing';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { CustomSpanishPaginator } from '@aurora/infrastructure/components/material-grid/grid/custom-paginator';
import { MsalModule, MsalService, MsalGuard, MsalInterceptor, MsalBroadcastService, MsalRedirectComponent } from '@azure/msal-angular';
import { PublicClientApplication, InteractionType, BrowserCacheLocation } from '@azure/msal-browser';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { environment } from 'environments/environment';
import { PowerBIEmbedModule } from 'powerbi-client-angular';
const routerConfig: ExtraOptions = {
    preloadingStrategy       : PreloadAllModules,
    scrollPositionRestoration: 'enabled',
};

@NgModule({
    declarations: [AppComponent],
    imports     : [
        MsalModule.forRoot(
            // MSAL Configuration
            new PublicClientApplication({
                auth: {
                    clientId   : environment.clientId,
                    authority  : environment.authority,
                    redirectUri: environment.redirectUri,
                },
                cache: {
                    cacheLocation         : BrowserCacheLocation.LocalStorage,
                    storeAuthStateInCookie: true, // set to true for IE 11
                },
                system: {
                    loggerOptions: {
                        loggerCallback   : () => {},
                        piiLoggingEnabled: false,
                    },
                },
            }),
            // MSAL Guard Configuration
            {
                interactionType: InteractionType.Redirect,
                authRequest    : {
                    scopes: [environment.scope],
                },
            },
            {
                interactionType     : InteractionType.Redirect,
                protectedResourceMap: new Map([
                    [
                        'https://graph.microsoft.com/v1.0/me',
                        [environment.scope],
                    ],
                    [
                        environment.api.graphql,
                        [environment.scope],
                    ],
                    [
                        'https://api.powerbi.com/v1.0/',
                        [
                            'https://analysis.windows.net/powerbi/api/Report.ReadWrite.All',
                            'https://analysis.windows.net/powerbi/api/Dataset.ReadWrite.All',
                        ],
                    ],
                    [
                        'https://pvt.azurewebsites.net/graphql',
                        [environment.scope],
                    ],
                ]),
            },
        ),
        BrowserModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(appRoutes, routerConfig),

        // Fuse, FuseConfig & FuseMockAPI
        FuseModule,
        FuseConfigModule.forRoot(appConfig),
        FuseMockApiModule.forRoot(mockApiServices),

        // Core module of your application
        CoreModule,

        // Layout module of your application
        LayoutModule,

        // Aurora front module
        AuroraModule,
        PowerBIEmbedModule,

        // 3rd party modules that require global configuration via forRoot
        MarkdownModule.forRoot({}),
    ],
    providers: [
        {
            provide    : AuroraLangService,
            useExisting: JsonLangService,
        },
        {
            provide : RouteReuseStrategy,
            useClass: RouteReuseStrategyService,
        },
        {
            provide : MatPaginatorIntl,
            useClass: CustomSpanishPaginator,
        },
        {
            provide : HTTP_INTERCEPTORS,
            useClass: MsalInterceptor,
            multi   : true,
        },
        MsalService,
        MsalGuard,
        MsalBroadcastService,
    ],
    bootstrap: [AppComponent, MsalRedirectComponent],
})
export class AppModule {}
